import apiUrls from "../urls";

export default function (api) {
	return {
		getData(ctx) {
			const query = {
				perPage: ctx.perPage,
				currentPage: ctx.currentPage,
				...(ctx?.orderBy?.field || ctx?.orderBy?.direction
					? {
							orderBy: {
								...(ctx.orderBy.field ? { field: ctx.orderBy.field } : {}),
								...(ctx.orderBy.field ? { field: ctx.orderBy.field } : {}),
							},
						}
					: {}),
			};
			return api.post(`${apiUrls.SELLER_SERVICE_ORDERS}`, query);
		},
		getDataDistributorList(ctx) {
			const query = {
				perPage: ctx.perPage,
				currentPage: ctx.currentPage,
			};

			// Добавляем статус если есть
			if (ctx.status) {
				query.status = ctx.status;
			}

			// Добавляем сортировку если есть
			if (ctx.orderBy?.field && ctx.orderBy?.direction) {
				query.orderBy = {
					field: ctx.orderBy.field,
					direction: ctx.orderBy.direction,
				};
			}

			return api.post(`${apiUrls.DIST_ORDER_LIST}`, query);
		},
		postApproveOrder(serviceOrderId, goods) {
			const requestData = {
				service_order_id: serviceOrderId,
				goods: goods,
			};
			return api.post(`${apiUrls.DIST_ORDER_ID_APPROVE}`, requestData);
		},
	};
}
